.td {
  border: var(--field-border) 1px solid;
  vertical-align: top;
  text-align: left;
}
